import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface PedidoDetailData {
  id: string;
  pedido_id: string;
  pedido_mae_id?: string | null;
  numero_pedido: number;
  cnpj: string;
  cpf?: string | null;
  tipo_pessoa?: string | null;
  razao_social: string;
  consultor_id?: string;
  consultor_nome?: string;
  total_venda_nova?: number;
  total_migracao?: number;
  total_faturamento?: number;
  // REMOVIDO: quadro_atual e coluna_atual (itens têm status, não pedidos)
  substatus_nome?: string;
  status_cor?: string;
  substatus_id?: string;
  gestor_nome?: string;
  gestor_telefone?: string;
  gestor_whatsapp?: string;
  gestor_email?: string;
  gestor_rg?: string;
  gestor_cpf?: string;
  cessionario_nome?: string;
  cessionario_telefone?: string;
  cessionario_whatsapp?: string;
  cessionario_email?: string;
  cessionario_rg?: string;
  cessionario_cpf?: string;
  data_referencia?: string;
  qtd_produtos?: number;
  cliente_id?: string;
  equipe_nome?: string;
  cliente_is_base?: boolean;
  cliente_origem_prime?: string;
  observacoes?: string;
  origem_lead?: string; // ✅ NOVO: Origem do lead (MANUAL, TABULACAO, etc)
  lead_origem_id?: string | null; // ✅ NOVO: ID do lead origem (para ver proposta original)
  sla_dias?: number;
  bko_criacao_nome?: string;
  bko_criacao_data?: string;
  bko_aceite_nome?: string;
  bko_aceite_data?: string;
  bko_input_nome?: string;
  bko_input_data?: string;
  owner_bko_nome?: string;
  dono_carteira_nome?: string;
  dono_carteira_equipe?: string;
  updated_at?: string;
  itens?: Array<{
    id: string;
    quadro_atual: string;
    coluna_atual: string;
  }>;
}

export function usePedidoDetail(pedidoId: string | null | undefined, enabled: boolean = true) {
  return useQuery({
    queryKey: ['pedido-detail', pedidoId],
    queryFn: async (): Promise<PedidoDetailData | null> => {
      if (!pedidoId) return null;

      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.access_token) throw new Error('Sessão expirada. Entre novamente no CRM.');

      const apiBase = (import.meta.env.VITE_SUPABASE_URL ?? 'https://beta.crm-api.primetecia.com.br/api')
        .replace(/\/+$/, '');
      const response = await fetch(`${apiBase}/v1/pedidos/${pedidoId}/detail`, {
        headers: { Authorization: `Bearer ${session.access_token}` },
      });
      const data = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(data?.error || 'Erro ao carregar pedido');
      }

      return data as PedidoDetailData;
    },
    enabled: enabled && !!pedidoId,
    staleTime: 30000,              // ✅ Cache por 30s (alinhado com ItensTab)
    gcTime: 300000,                // ✅ Manter em memória por 5min
    refetchOnWindowFocus: false,   // ✅ Não re-fetch ao focar janela
    refetchOnMount: false,         // ✅ Não re-fetch ao montar
    refetchOnReconnect: false,     // ✅ Não re-fetch ao reconectar
  });
}
